import appStore from '@loyal_images/app-store.svg'
import logo from '@loyal_images/brand/logo_bg_light.png'
import play from '@loyal_images/google-play.svg'
import '@loyal_molecules/footer.css'
import { MenuMobileContainer } from 'App/MainMenu/MenuMobile'
import { Icon } from 'loyal-react'
import PropTypes from 'prop-types'
import React, { Component, Fragment } from 'react'
import ReactPlaceholder from 'react-placeholder'
import 'react-placeholder/lib/reactPlaceholder.css'
import MediaQuery from 'react-responsive'
import { Link } from 'react-router-dom'
import yn from 'yn'
import FooterPlaceholder from '../../App/Footer/FooterPlaceholder'
import IuppContactList from '../../App/Footer/IuppContactList'
import { getButton } from 'Shared/GTM/getButton'

class Footer extends Component {
  constructor (props) {
    super(props)
    this.profileMenuState = this.profileMenuState.bind(this)
    this.callReset = this.callReset.bind(this)
    this.activePage = this.activePage.bind(this)

    this.state = {
      profileMenu: false,
      userMenu: false,
      categoryMenu: true,
      isHomeOrGuest: false,
      isHelpPage: false,
      isProfile: false,
      isCartPage: false,
      openNPS: false,
      showIuppMobileMenu: false
    }
  }

  state = {
    isHomeOrGuest: false,
    isHelpPage: false,
    isWishlistPage: false,
    isCartPage: false,
    profileMenu: false,
    userMenu: false,
    stateMenu: true,
    categoryMenu: false,
    showIuppMobileMenu: false
  }

  openProfileMenu = () => {
    setTimeout(() => {
      if (this.state.userMenu === true) {
        this.setState({
          profileMenu: false,
          userMenu: false
        })
      } else {
        this.setState({
          profileMenu: true,
          userMenu: true,
          categoryMenu: false,
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false
        })
      }
    }, 300)
  }

  openCategoryMenu = () => {
    setTimeout(() => {
      if (this.state.categoryMenu === true) {
        this.setState({
          categoryMenu: false
        })
      } else {
        this.setState({
          profileMenu: false,
          userMenu: false,
          categoryMenu: true,
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false
        })
      }
    }, 300)
  }
  callReset = e => {
    this.setState({
      stateMenu: !this.state.stateMenu
    })
    if (
      !this.state.stateMenu ||
      this.state.categoryMenu ||
      this.state.userMenu
    ) {
      setTimeout(() => {
        this.setState({
          profileMenu: false,
          userMenu: false,
          categoryMenu: false
        })
      }, 300)
    }
  }

  closeMenu = () => {
    var checkMenu = document.getElementById('menuToggle')
    if (checkMenu && checkMenu.checked === true) {
      checkMenu.checked = false
    }
    this.callReset()
  }

  // Apenas para o modo responsivo
  activePage = () => {
    this.closeMenu()
    setTimeout(() => {
      var activeRoute = window.location.pathname.substring(
        window.location.pathname.lastIndexOf('/')
      )

      if (activeRoute === '/') {
        this.setState({
          isHomeOrGuest: true,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (activeRoute === '/faq') {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: true,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (
        activeRoute === '/profile' ||
        activeRoute === '/wishlist' ||
        activeRoute === '/extract' ||
        activeRoute === '/my-orders' ||
        activeRoute === '/my-address' ||
        activeRoute === '/scheduling'
      ) {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: true,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      } else if (activeRoute === '/cart') {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: true,
          showIuppMobileMenu: false
        })
      } else {
        this.setState({
          isHomeOrGuest: false,
          isHelpPage: false,
          isProfile: false,
          isCartPage: false,
          showIuppMobileMenu: false
        })
      }
    }, 1)
  }

  profileMenuState () {
    this.setState({
      profileMenu: !this.state.profileMenu
    })
  }
  openNPS () {
    this.setState({
      openNPS: !this.state.openNPS
    })
  }
  componentDidMount () {
    this.activePage()
  }
  toggleMenuMobileIupp () {
    this.setState({
      showIuppMobileMenu: !this.state.showIuppMobileMenu,
      isHomeOrGuest: !this.state.isHomeOrGuest
    })
  }

  render () {
    return (
      <ReactPlaceholder ready customPlaceholder={<FooterPlaceholder />}>
        <footer className='box-footer d-print-none' role='contentinfo'>
          <MediaQuery maxDeviceWidth={1025}>
            {yn(process.env.REACT_APP_FOOTERIUPP) && (
              <section className={this.state.showIuppMobileMenu ? 'open-menu-iupp menu-mobile-iupp' : 'close-menu-iupp menu-mobile-iupp'}>
                <section className='menu-mobile menu'>
                  <nav>
                    <div className='flexible-items-container'>
                      <Link
                        onClick={() => {
                          this.toggleMenuMobileIupp()
                          getButton(false, 'home', 'clique:menu', 'beneficios', 'meu-negocio')
                        }}
                        to='/meu-negocio/#benefits'
                        data-target='#benefits'
                        className='flex-item mn-item mn-benefits'
                        title='benefícios que vão te ajudar a vender mais.'
                        tabIndex={0}
                      >
                        benefícios
                      </Link>
                      <Link
                        onClick={() => {
                          this.toggleMenuMobileIupp()
                          getButton(false, 'home', 'clique:menu', 'ajuda', 'meu-negocio')
                        }}
                        to='/meu-negocio/#help'
                        data-target='#help'
                        className='flex-item mn-item mn-help'
                        title='está com dúvidas? veja nossas perguntas frequentes.'
                        tabIndex={0}
                      >
                        ajuda
                      </Link>
                      <a
                        href={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_LOGIN}
                        className='flex-item mn-item mn-login'
                        title='Ir para para area de login'
                        tabIndex={0}
                        onClick={() => getButton(false, 'home', 'clique:botao', 'entrar', 'meu-negocio')}
                      >
                        entrar
                      </a>
                      <a
                        href={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP}
                        className='flex-item mn-item mn-register'
                        title='Fazer cadastro'
                        tabIndex={0}
                        onClick={() => getButton(false, 'home', 'clique:botao', 'cadastre-se', 'meu-negocio')}
                      >
                        cadastre-se
                      </a>
                    </div>
                  </nav>
                </section>
              </section>
            )}
            <div className='box-footer-mobile'>
              <div className='container-footer footer-part-mobile bg-brand-2 container-fluid row mx-0 px-0'>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.isHomeOrGuest ? 'active' : 'inactive'
                  }`}>
                  <Link
                    to='/meu-negocio'
                    className='color-ui-white txt-body-sm d-flex justify-content-center'
                    onClick={() => {
                      this.activePage()
                      getButton(false, 'home', 'clique:menu', 'inicio-meu-negocio', 'meu-negocio')
                    }}
                    onFocus={() => this.callReset()}
                    tabIndex={0}
                  >
                    <Icon className='icon icon_home color-ui-white' />
                    <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half txt-menu-mobile'>
                      Início
                    </p>
                  </Link>
                </div>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.showIuppMobileMenu ? 'active' : 'inactive'
                  }`}
                >
                  {this.props.profile ? (
                    <Fragment>
                      <a
                        className='not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center'
                        onClick={() => this.openCategoryMenu()}
                        aria-haspop='true'
                        aria-expanded={this.state.categoryMenu}
                        onFocus={() => this.callReset()}
                        role='button'
                        href='javascript:void(0)'
                        tabIndex={0}
                      >
                        <Icon
                          className={`icon icon_${
                            this.state.categoryMenu
                              ? 'menu_app_close'
                              : 'menu_app'
                          } color-${
                            this.state.categoryMenu
                              ? 'brand-6 txt-body'
                              : 'brand-5'
                          }`}
                        />
                        <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'>
                          Menu
                        </p>
                      </a>
                      {this.state.categoryMenu && (
                        <MenuMobileContainer
                          stateMenu={this.state.stateMenu}
                          callReset={this.callReset}
                          profileMenu={this.state.profileMenu}
                          profileMenuState={this.profileMenuState}
                          categoryMenu={this.state.categoryMenu}
                          userMenu={this.state.userMenu}
                          activePage={this.activePage}
                        />
                      )}
                    </Fragment>
                  ) : yn(process.env.REACT_APP_FOOTERIUPP) ? (
                    <a className='color-ui-white txt-body-sm d-flex justify-content-center'
                      onClick={() => this.toggleMenuMobileIupp()}
                      onFocus={() => this.callReset()}
                      tabIndex={0}>
                      <Icon
                        className={`icon icon_${
                          this.state.showIuppMobileMenu
                            ? 'menu_app_close'
                            : 'menu_app'
                        } color-${
                          this.state.showIuppMobileMenu
                            ? 'brand-6 txt-body'
                            : 'brand-5'
                        }`}
                      />
                      <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'>
                        Menu
                      </p>
                    </a>
                  ) : (
                    <Link
                      to='/auth/login'
                      className='color-ui-white txt-body-sm d-flex justify-content-center'
                      tabIndex={0}
                    >
                      <Icon
                        className={`icon icon_${
                          this.state.categoryMenu
                            ? 'menu_app_close'
                            : 'menu_app'
                        } color-${
                          this.state.categoryMenu
                            ? 'brand-6 txt-body'
                            : 'brand-5'
                        }`}
                      />
                      <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'>
                        Menu
                      </p>
                    </Link>
                  )}
                </div>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.isCartPage ? 'active' : 'inactive'
                  }`}
                >
                  {yn(process.env.REACT_APP_FOOTERIUPP) && !this.props.profile ? (
                    <Link
                      to={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_SIGNUP}
                      className='color-ui-white txt-body-sm d-flex justify-content-center'
                      onClick={() => {
                        this.activePage()
                        getButton(false, 'home', 'clique:botao', 'cadastre-se', 'meu-negocio')
                      }}
                      onFocus={() => this.callReset()}
                      tabIndex={0}
                    >
                      <Icon
                        className={`icon icon_login color-${
                          this.state.isCartPage ? 'brand-6' : 'brand-5'
                        }`}
                      />
                      <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'>
                        Cadastre-se
                      </p>
                    </Link>
                  ) : ''}
                </div>
                <div
                  className={`col px-0 d-flex justify-content-center ${
                    this.state.isProfile ? 'active' : 'inactive'
                  }`}
                >
                  {this.props.profile ? (
                    <Fragment>
                      <a
                        className='not-a-button LikeA color-ui-white txt-body-sm d-flex justify-content-center'
                        aria-haspop='true'
                        aria-expanded={this.state.userMenu}
                        onClick={() => this.openProfileMenu()}
                        onFocus={() => this.callReset()}
                        role='button'
                        href='javascript:void(0)'
                        tabIndex={0}
                      >
                        <Icon
                          className={`icon icon_${
                            this.state.userMenu ? 'menu_app_close' : 'profile'
                          } color-${
                            this.state.userMenu ? 'brand-6 txt-body' : 'brand-5'
                          }`}
                        />
                        <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'>
                          {this.props.profile ? 'Perfil' : 'Entrar'}
                        </p>
                      </a>
                      {this.state.userMenu && (
                        <MenuMobileContainer
                          stateMenu={this.state.stateMenu}
                          callReset={this.callReset}
                          profileMenu={this.state.profileMenu}
                          profileMenuState={this.profileMenuState}
                          categoryMenu={this.state.categoryMenu}
                          userMenu={this.state.userMenu}
                          activePage={this.activePage}
                        />
                      )}
                    </Fragment>
                  ) : (
                    <Link
                      to={process.env.REACT_APP_MEU_BAIRRO_ENDPOINT_LOGIN}
                      className='color-ui-white txt-body-sm d-flex justify-content-center'
                      tabIndex={0}
                    >
                      <Icon className='icon icon_profile color-ui-white' />
                      <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'>
                        {this.props.profile ? 'Perfil' : 'Entrar'}
                      </p>
                    </Link>
                  )}
                </div>
                {yn(process.env.REACT_APP_HAS_FAQ_LINK) && (
                  <div
                    className={`col px-0 d-flex justify-content-center ${
                      this.state.isHelpPage ? 'active' : 'inactive'
                    }`}
                  >
                    <Link to='/redirect/faq'
                      className='color-ui-white txt-body-sm d-flex justify-content-center'
                      onClick={() => {
                        this.activePage()
                        getButton(false, 'home', 'clique:menu', 'ajuda', 'meu-negocio')
                      }}
                      onFocus={() => this.callReset()}
                      tabIndex={0}>
                      <Icon className='icon icon_question color-ui-white' />
                      <p className='pos-absolute t-2 color-ui-white txt-subtitle pt-half  txt-menu-mobile'>
                        Ajuda
                      </p>
                    </Link>
                  </div>
                )}
              </div>
            </div>
          </MediaQuery>
          <MediaQuery minDeviceWidth={1026}>
            <div className='box-footer-desktop'>
              <div className='container-footer footer-part-1 bg-brand-4 container-fluid py-4 d-none'>
                <div className='container py-1'>
                  <div className='row'>
                    <div className='address col-12 col-md-6 align-self-center'>
                      <div className='row'>
                        <div className='col-12 col-md-3 pl-0 pr-2 txt-center'>
                          <img
                            src={logo}
                            className='address-logo'
                            alt='LTM Fidelidade'
                          />
                        </div>
                        <div className='col-12 col-md-8 align-self-center mt-3 mt-md-0'>
                          <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                            Alameda Rio Negro, 585 - 13º andar
                          </p>
                          <p className='txt-body-sm  color-ui-white txt-center txt-md-left'>
                            Alphaville - Barueri - SP - CEP 06454-000
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className='app col-12 col-md-6 d-none'>
                      <div className='row'>
                        <div className='col-12 col-md-6 txt-right downloadit-app txt-circular-book txt-center txt-md-right mt-3 mt-md-0 align-self-center'>
                          <span className='txt-customsize-20x28 d-block'>
                            Baixe agora o app.
                          </span>
                        </div>
                        <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                          <img
                            className='img-h-100 img-w-auto google-play'
                            src={play}
                            alt='Baixe o aplicativo no Google play'
                          />
                        </div>
                        <div className='col-12 col-md-3 logo-app txt-center mt-2 mt-md-0'>
                          <img
                            className='img-h-100 img-w-auto app-store'
                            src={appStore}
                            alt='Baixe o aplicativo na App Store'
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='container-footer footer-part-2 bg-ui-1 container-fluid d-none d-md-block'>
                <div className='container'>
                  {yn(process.env.REACT_APP_FOOTERIUPP) ? (
                    <IuppContactList profile={this.props.profile} />
                  ) : (
                    <div className='row'>
                      <nav
                        aria-label='Rodapé'
                        className='links col-12 px-0 py-3'
                      >
                        <ul className='row'>
                          {yn(process.env.REACT_APP_HAS_SECURITY_LINK) && (
                            <li
                              className='col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0'
                              data-href='/security'
                            >
                              <Link
                                className='color-ui-white txt-body-sm'
                                to='/security'
                                tabIndex={0}
                                onClick={() => getButton(false, 'home', 'clique:botao', 'termos-seguranca', 'meu-negocio')}
                                target='_blank'
                              >
                                Segurança
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_REGULATION_LINK) && (
                            <li
                              className='col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0'
                              data-href='/regulation'
                            >
                              <Link
                                className='color-ui-white txt-body-sm'
                                to='/regulation'
                                tabIndex={0}
                                target='_blank'
                                onClick={() => getButton(false, 'home', 'clique:botao', 'termos-regulamentos', 'meu-negocio')}
                              >
                                Regulamentos
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_PRIVACY_LINK) && (
                            <li
                              className='col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0'
                              data-href='/privacy'
                            >
                              <Link
                                className='color-ui-white txt-body-sm'
                                to='/privacy'
                                tabIndex={0}
                                target='_blank'
                                onClick={() => getButton(false, 'home', 'clique:botao', 'termos-privacidade', 'meu-negocio')}
                              >
                                Politica de Privacidade
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_TERMS_LINK) && (
                            <li
                              className='col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0'
                              data-href='/terms'
                            >
                              <Link
                                className='color-ui-white txt-body-sm'
                                to='/terms'
                                tabIndex={0}
                                target='_blank'
                                onClick={() => getButton(false, 'home', 'clique:botao', 'termos-de-uso', 'meu-negocio')}
                              >
                                Termos de uso
                              </Link>
                            </li>
                          )}
                          {yn(process.env.REACT_APP_HAS_FAQ_LINK) && (
                            <li
                              className='col-12 col-md-3 pl-md-1 pr-md-4 px-4 txt-center txt-md-left my-1 my-md-0'
                              data-href='/redirect/faq'
                            >
                              <Link
                                className='color-ui-white txt-body-sm'
                                to='/redirect/faq'
                                tabIndex={0}
                                target='_blank'
                                onClick={() => getButton(false, 'home', 'clique:botao', 'faq', 'meu-negocio')}
                              >
                                Ajuda
                              </Link>
                            </li>
                          )}
                        </ul>
                      </nav>
                    </div>
                  )}
                  <div className='row mx-0 px-0'>
                    <div className='legal col-12 col-md-10 px-0 py-3' role='contentinfo'>
                      {process.env.SKIN !== 'iupp' ? (
                        <p tabIndex={0} className='color-ui-white txt-subtitle txt-center txt-md-left'>
                          {
                            process.env.REACT_APP_MESSAGE_FOOTER_LEGAL || 'PREMMIAR SERVICOS DE FIDELIZACAO LTDA. CNPJ: 33.957.023/0001-48 - Inscrição Estadual: 206.561.177.119'
                          }
                        </p>
                      ) : ('')}
                      <p tabIndex={0} className='color-ui-white txt-subtitle txt-center txt-md-left'>
                        O catálogo de premiação é atualizado periódica e
                        automaticamente pelos parceiros e os produtos e preços
                        poderão sofrer alterações durante a navegação, sem aviso
                        prévio, devendo ser consultados pelo interessado no
                        momento da conclusão efetiva do resgate.
                      </p>
                    </div>
                    {!yn(process.env.REACT_APP_FOOTERIUPP) && (
                      <div
                        className='address col-2 align-self-center txt-center logo-footer'
                        role='img'
                        aria-label={process.env.REACT_APP_TITLE || ''}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </MediaQuery>
        </footer>
      </ReactPlaceholder>
    )
  }
}

Footer.propTypes = {
  profile: PropTypes.object
}
export default Footer



// WEBPACK FOOTER //
// ./src/HomePageItauMeuBairro/Footer/index.js